import { createRootRoute, Link, Outlet } from "@tanstack/react-router";

export const rootRoute = createRootRoute({
  component: Outlet,
  notFoundComponent: () => (
    <div className="flex h-dvh flex-col items-center justify-center gap-3 text-center">
      <h1 className="font-serif text-2xl text-stone-800">Page introuvable</h1>
      <Link to="/" className="text-sm text-rose-700 underline">
        Retour à l'accueil
      </Link>
    </div>
  ),
});
